import React, { useState, useEffect } from 'react';
import { profileData, skills, services, projects, certifications } from '../mock';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Skills from '../components/Skills';
import Projects from '../components/Projects';
import Certifications from '../components/Certifications';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const Portfolio = () => {
  const [activeSection, setActiveSection] = useState('home');

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['home', 'services', 'skills', 'projects', 'certifications', 'contact'];
      const scrollPosition = window.scrollY + 100;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const offsetTop = element.offsetTop;
          const offsetHeight = element.offsetHeight;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="portfolio-container">
      <Header activeSection={activeSection} />
      <main>
        <Hero data={profileData} />
        <Services data={services} />
        <Skills data={skills} />
        <Projects data={projects} />
        <Certifications data={certifications} />
        <Contact data={profileData} />
      </main>
      <Footer data={profileData} />
    </div>
  );
};

export default Portfolio;